module.exports = __webpack_public_path__ + "static/images/pass-card-half.e425cf6.png";